import React from 'react';
import AuthGuard from '../AuthGuard';
import PortCoGuard from '../PortCoGuard';

const AuthPortCoGuard = ({ children }: { children: React.ReactNode }) => {
  return (
    <AuthGuard>
      <PortCoGuard>{children}</PortCoGuard>
    </AuthGuard>
  );
};

export default AuthPortCoGuard;
